export const IMAGE_BASE_URL = "https://d1lk87rn3i1znm.cloudfront.net/";
export const BASE_URL = "https://belivmart.com";
export const MSG91 = {
  WIDGET_ID: "3566786b6541323537383136",
  TOKEN_AUTH: "447148TWWDv3ZKl5qU68001eadP1",
};
export const PRODUCT = {
  TYPE: {
    COMMON_PRODUCT: "CommonProduct",
    SERVICE: "Service",
    PRODUCT: "Product",
  },
};

export const CUSTOMER = {
  USER_DEVICE_TYPE: {
    CustomerMobileApp: "CustomerMobileApp",
    CustomerWebApp: "CustomerWebApp",
  },
};

export const ORDER = {
  STATUS: {
    CustomerConfirmationPending: 'CustomerConfirmationPending',
    MerchantAcceptancePending: 'MerchantAcceptancePending',
    MerchantPreparing: 'MerchantPreparing',
    ReadToPickup: 'ReadToPickup',
    OutForDelivery: 'OutForDelivery',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled',
  }
}

export const POST_LOGIN_ACTION = {
  ADD_NEW_ADDRESS: "ADD_NEW_ADDRESS",
};

export const DISPLAY_CATEGORY_TYPE = {
  Food: "Food",
  GroceryProduct: "Grocery_Product",
  Service: "Service",
};

export const CUSTOMER_PRODUCT = {
  POST_TYPE:{
    PRODUCT: "Product",
    JOB: "Job",
  }
}

export const CUSTOMER_PRODUCT_POST_TYPE_MAP = {
  TITLE:{
    [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "ReSell",
    [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Jobs",
  },
  SUB_TITLE:{
    [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "Buy / Sell Old Products",
    [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Find / Post Jobs",
  },
  BUTTON_TEXT:{
    [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "Product",
    [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Job",
  },
  ADD_PRODUCT_PAGE_TITLE:{
    [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "Sell Your Old Products",
    [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Add Job",
  },
  ADD_PRODUCT_FILED_NAME: {
    SELLING_PRICE: {
      [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "Selling Price",
      [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Monthly Salary",
    },

    ADDRESS: {
      [CUSTOMER_PRODUCT.POST_TYPE.PRODUCT]: "Select Address",
      [CUSTOMER_PRODUCT.POST_TYPE.JOB]: "Job/Office Address",
    },
  
  }
}

export const EVENT_NAME = {
  AREA_SELECTED: "Area Selected",
  SEARCH_PRODUCT: "Search Product",
  CATEGORY_CLICKED: "Category Clicked",
  MERCHANT_CLICKED: "Merchant Clicked",
  ORDER_PLACED: "Order Placed",
  LOGIN_PAGE_VIEWED: "Login Page Viewed",
  LOGIN_OTP_SENT: "Login OTP Sent",
  LOGIN_OTP_VERIFICATION_ATTEMPTED: "Login OTP Verification Attempted",
  LOGIN_OTP_VERIFICATION_SUCCESS: "Login OTP Verification Success",
  LOGIN_OTP_VERIFICATION_FAILED: "Login OTP Verification Failed",
  LOGIN_SUCCESS: "Login Success",
  LOGIN_FAILED: "Login Failed",
  EDIT_NUMBER: "Edit Number",
  RESEND_OTP: "Resend OTP",
  ADDRESS_SELECTED: "Address Selected",
  ADDRESS_DELETED: "Address Deleted",
  ADDRESS_ADDED: "Address Added",
  ADDRESS_MAP_LOCATION_UPDATED: "Address Map Location Updated",
  CART_VIEWED: "Cart Viewed",
  COMMON_PRODUCT_MERCHANT_CHANGE: "Common Product Merchant Change",
  CART_PRODUCT_QUANTITY_DECREASED: "Cart Product Quantity Decreased",
  CART_PRODUCT_QUANTITY_INCREASED: "Cart Product Quantity Increased",
  CART_PRODUCT_ADDED: "Cart Product Added",

  CUSTOMER_PRODUCT_VIEWED: "Customer Product Viewed",
  CUSTOMER_PRODUCT_CONTACTED: "Customer Product Contacted",
  CUSTOMER_PRODUCT_ADDED: "Customer Product Added",
  CUSTOMER_PRODUCT_ADD_BUTTON_CLICKED: "Customer Product Add Button Clicked",

  ORDER_RATE_FEEDBACK_SUBMITTED: "Order Rate Feedback Submitted",
};

export const AREA = {
  EXTRA_DETAILS: {
    UI: {
      TAB: {
        TYPE: {
          Food: "Food",
          Grocery_Product: "Grocery_Product",
          Merchant: "Merchant",
          Service: "Service",
          Customer_Product: "Customer_Product",
          Customer_Product_Job: "Customer_Product_Job",
        },
        STATUS: {
          Active: "Active",
          InActive: "InActive",
        },
      },
    },
  },
};

export const UI_TAB_LIST = [
  {
    name: "Food",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Food,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  },
  {
    name: "Products",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Grocery_Product,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  },
  {
    name: "Shops",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Merchant,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  },
  {
    name: "Service",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Service,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  },
  {
    name: "ReSell",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Customer_Product,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  },
  {
    name: "Jobs",
    type: AREA.EXTRA_DETAILS.UI.TAB.TYPE.Customer_Product_Job,
    status: AREA.EXTRA_DETAILS.UI.TAB.STATUS.Active,
  }
];

export const FILE_ENTITY_TYPE = {
  PRODUCT_IMAGE: 'product_image',
  CATEGORY_IMAGE: 'category_image',
  DISPLAY_CATEGORY_IMAGE: 'display_category_image',
  MERCHANT_IMAGE: 'merchant_image',
  CUSTOMER_PRODUCT_FILE: 'customer_product_file',
};
